<c-workflow-details workflow-id="workflowId" class="modal-view" module="rootState"></c-workflow-details>